module.exports = __webpack_public_path__ + "img/e6.41c4113b.jpg";